import { updateKYC } from './states';

export const services = {
  updateKYC,
};
